/* Free Shipping Progress Bar
   -----------------------------------------------------------------
   Theme-agnostic by design:
   - Reads cart totals from Shopify's own /cart.js endpoint (every
     theme exposes this — nothing Savor-specific).
   - Detects cart changes by patching fetch() and XMLHttpRequest, so
     it works whether the theme's add-to-cart uses modern fetch or
     older jQuery/XHR code, and even works with third-party apps
     that add to cart.
   - Formats money using the store's own shop.money_format string
     (passed in via a data attribute), so it always matches whatever
     currency formatting is set in Settings > General.
   - Matches the button color of whatever theme is running by
     reading the computed style of an existing button, instead of
     guessing theme-specific CSS variable names.
*/
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';

    function withDelimiters(number, precision, thousands, decimalMark) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimalMark = typeof decimalMark === 'undefined' ? '.' : decimalMark;
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimalMark + parts[1] : '';
      return whole + fraction;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;

    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function detectAccentColor() {
    var selectors = [
      'button[name="checkout"]',
      '.cart-drawer__checkout',
      '.cart__checkout-button',
      '.cart-checkout-button',
      'form[action*="/cart"] button[type="submit"]',
      '.shopify-payment-button__button--unbranded',
      '.button--primary',
      '.btn--primary',
      '.product-form__submit',
      'button.button',
      'a.button'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      var style = window.getComputedStyle(el);
      if (style.backgroundColor && style.backgroundColor !== 'rgba(0, 0, 0, 0)' && style.backgroundColor !== 'transparent') {
        return style.backgroundColor;
      }
      if (style.borderColor && style.borderColor !== 'rgba(0, 0, 0, 0)') {
        return style.borderColor;
      }
      if (style.color) {
        return style.color;
      }
    }
    return null;
  }

  function updateBar(root, cart) {
    var thresholdCents = parseInt(root.getAttribute('data-threshold-cents'), 10) || 0;
    var format = root.getAttribute('data-money-format') || '{{amount}}';
    var total = cart.total_price || 0;
    var remaining = thresholdCents - total;
    if (remaining < 0) remaining = 0;
    var progress = thresholdCents > 0 ? Math.min(100, (total / thresholdCents) * 100) : 100;

    var fill = root.querySelector('[data-fsb-fill]');
    var track = root.querySelector('[data-fsb-track]');
    var message = root.querySelector('[data-fsb-message]');

    if (fill) fill.style.width = progress + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));

    if (message) {
      if (remaining > 0) {
        message.innerHTML = 'You\'re <strong>' + formatMoney(remaining, format) + '</strong> away from free shipping!';
        root.classList.remove('fsb--complete');
      } else {
        message.innerHTML = '🎉 You\'ve unlocked free shipping!';
        root.classList.add('fsb--complete');
      }
    }

    var accent = detectAccentColor();
    if (accent) root.style.setProperty('--fsb-accent', accent);
  }

  function syncAll() {
    var roots = document.querySelectorAll('[data-fsb]');
    if (!roots.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        roots.forEach(function (root) { updateBar(root, cart); });
      })
      .catch(function () {});
  }

  var syncTimer = null;
  function debouncedSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncAll, 120);
  }

  var CART_ACTION_PATTERN = /\/cart\/(add|update|change|clear)(\.js)?/;

  if (!window.__fsbFetchPatched) {
    window.__fsbFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartAction = CART_ACTION_PATTERN.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartAction) {
        result.then(debouncedSync).catch(function () {});
      }
      return result;
    };
  }

  if (!window.__fsbXhrPatched) {
    window.__fsbXhrPatched = true;
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fsbIsCartAction = CART_ACTION_PATTERN.test(url || '');
      return originalOpen.apply(this, arguments);
    };
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__fsbIsCartAction) {
        this.addEventListener('loadend', debouncedSync);
      }
      return originalSend.apply(this, arguments);
    };
  }

  ['cart:updated', 'cart:refresh', 'cart:build', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, debouncedSync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
